import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { Dialog } from 'primereact/dialog';
import { Dropdown, DropdownChangeEvent, DropdownProps } from 'primereact/dropdown';
import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';
import { Toast } from 'primereact/toast';
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Nullable } from "primereact/ts-helpers";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { getAppCurrencyType } from "../../Utils/Common";
import TextInput from "../../Components/TextInput";
import { Project, searchProjectAdderss, ServiceType, serviceType, SubscriptionDetails } from "../../Controllers/Types/Project/ProjectInterface";
import { projectCreateAPI, projectDeleteAPI, projectLicenseUpdateAPI, projectUpdateAPI, searchProjectAddressGetAPI, serviceTypeCreateAPI, serviceTypeGetAPI, subscriptionDetailsGetAPI } from "../../Api/ProjectApi";
import { checkNumber, checkText } from "../../Utils/Validator";
import { useAppDispatch } from "../../Controllers/hooks";
import { fetchAllProjectAfterEdit, fetchAllProjects } from "../../Controllers/Thunks/projectThunks";
import { InputNumber, InputNumberChangeEvent } from "primereact/inputnumber";
import { goToTop } from "../../Components/goToTop";
import { appStoreLink, playStoreLink } from "../../../Website/Utils/Info";
import { confirmDialog } from "primereact/confirmdialog";
import { mapPaymentTypes, PaymentType } from "../../Controllers/Types/ApiResponse";
import { getPaymentTypes } from "../../Api/CommonApi";
import { Image } from "primereact/image";
import { baseURL } from "../../Api/ApiConstant";
import { Skeleton } from "primereact/skeleton";
import { Tooltip } from "primereact/tooltip";
import CheckoutForm from "../PaymentGateWay/CheckoutForm";
import { PaymentIntent } from "@stripe/stripe-js";
import { buyLicense } from "../../Api/PaymentGateWay/PaymentGateWayApiService";
import TableActionLoader from "../../Components/TableActionLoader";
import { checkIsBuildingInspector } from "../../Utils/LoginUserRoleName";

interface Status {
    name: string;
}

interface ProjectModalProps {
    isOpen: boolean;
    dataState: 'Add' | 'Edit' | 'Renewal';
    onClose: () => void;
    onSuccess: (message: string) => void;
    onRenewalClose?: () => void;
    toast: React.RefObject<Toast>;
    projectDetails?: Project;
}

const ProjectModal: React.FC<ProjectModalProps> = ({
    isOpen,
    dataState,
    onClose,
    onSuccess,
    onRenewalClose,
    toast,
    projectDetails,
}) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const currencySymbol = getAppCurrencyType();

    const [loading, setLoading] = useState<boolean>(false);
    const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
    const [showLicenceModal, setShowLicenceModal] = useState<boolean>(false);
    const [showSubscriptionModal, setShowSubscriptionModal] = useState<boolean>(false);
    const [projectUpdateHasChanges, setProjectUpdateHasChanges] = useState<boolean>(false);

    const [projectSubscription, setProjectSubscription] = useState<SubscriptionDetails | null>(null);

    /* ***************************** project create base data - start ****************************************************************** */
    const [allProjectAddress, setAllProjectAddress] = useState<searchProjectAdderss[]>([]);
    const [selectedProjectAddress, setSelectedProjectAddress] = useState<searchProjectAdderss | null>(null);

    const [allServiceType, setAllServiceType] = useState<serviceType[]>([]);
    const [subscriptionDetails, setSubscriptionDetails] = useState<SubscriptionDetails[]>([]);
    /* ***************************** project create base data - end ******************************************************************** */

    /********************************** Project form variables *************************************/
    const statuses: Status[] = [
        { name: "Current" },
        { name: "Ongoing" },
        { name: "Completed" }
    ];

    const [jobNo, setJobNo] = useState<Nullable<number>>(null);
    const [contactId, setContactId] = useState<number | null>(null);
    const [commercialClientProjectInfoId, setCommercialClientProjectInfoId] = useState<number | null>(null);
    const [domesticClientInfoId, setDomesticClientInfoId] = useState<number | null>(null);
    const [projectType, setProjectType] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [serviceType, setServiceType] = useState<ServiceType[]>([]);
    const [status, setStatus] = useState<Status | null>(statuses[0]);
    const [assignLicence, setAssignLicence] = useState<SubscriptionDetails | null>(null);
    const [selectedLicence, setSelectedLicence] = useState<string | null>(null);
    const [licence, setLicence] = useState<number | null>(null);
    /* create new service type */
    const [serviceTypeName, setServiceTypeName] = useState<string>('');
    const [errorServiceTypeName, setErrorServiceTypeName] = useState<string>('');
    const [showAddCustomData, setShowAddCustomData] = useState<boolean>(false);
    /**********************************************************************************************/

    /* Project error massage */
    const [errorJobNo, setErrorJobNo] = useState<string>('');
    const [errorProjectAddress, setErrorProjectAddress] = useState<string>('');
    const [errorProjectType, setErrorProjectType] = useState<string>('');
    const [errorDescription, setErrorDescription] = useState<string>('');
    const [errorServiceType, setErrorServiceType] = useState<string>('');
    const [errorStatus, setErrorStatus] = useState<string>('');
    const [errorLicence, setErrorLicence] = useState<string>('');

    /* ******************************************************************************************************************************************** */

    const [showLicensePurchaseModal, setShowLicensePurchaseModal] = useState<boolean>(false);
    const [paymentMethodsData, setPaymentMethodsData] = useState<PaymentType[]>([]);
    const [loadingPaymentMethods, setLoadingPaymentMethods] = useState<boolean>(false);
    const [showCheckoutForm, setShowCheckoutForm] = useState<boolean>(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<PaymentType | null>(null);
    const [paidTotal, setPaidTotal] = useState<number>(0);

    /* ************************************************************************************************************************ */

    const [dataAddLoading, setDataAddLoading] = useState<boolean>(false);


    /* Check role */
    const [isInspector, setIsInspector] = useState<boolean>(false);

    useEffect(() => {
        const checkRole = async () => {
            const [inspectorResult] = await Promise.all([
                checkIsBuildingInspector(),
            ]);

            setIsInspector(inspectorResult);
        };

        checkRole();
    }, []);
    /*  */

    useEffect(() => {
        GetAllProjectAddress();
        GetAllServiceType();
        GetAllSubscriptionDetails();
    }, []);

    useEffect(() => {
        if (isOpen) {
            setUpdateData();
        }
    }, [isOpen, dataState, projectDetails]);

    useEffect(() => {
        const fetchProjectSubscriptionData = async () => {
            if (projectDetails && projectDetails !== null) {

                const subscription = subscriptionDetails.find(
                    (plan) => plan?.subscription_id === projectDetails?.subscription_id
                );

                if (subscription && subscription?.monthly_subscription_amount === 0) {
                    const payablesubscription = subscriptionDetails.filter(
                        (plan) => plan.monthly_subscription_amount !== 0
                    );

                    if (payablesubscription && payablesubscription.length > 0) {
                        setProjectSubscription(payablesubscription[0]);
                    }
                } else {
                    setProjectSubscription(subscription || null);
                }
            }
        };
        fetchProjectSubscriptionData();
    }, [projectDetails, subscriptionDetails]);

    const setUpdateData = async () => {
        if (dataState === 'Add') {
            clearAllInputValue();
        } else if (dataState === 'Edit') {
            setJobNo(projectDetails?.job_number);
            setDescription(projectDetails?.description || '');

            /* ******** project address data set ********* */
            let allProjectAddressList: searchProjectAdderss[] | [];

            if (allProjectAddress.length === 0) {
                allProjectAddressList = await GetAllProjectAddress();
            } else {
                allProjectAddressList = allProjectAddress;
            }

            let projectAddressData: searchProjectAdderss | null = null;

            if ((projectDetails?.project_type)?.toLowerCase() === "commercial") {
                projectAddressData = allProjectAddressList.filter(address => address.commercial_client_id === projectDetails?.commercial_client_project_info_id)[0];
            } else {
                projectAddressData = allProjectAddressList.filter(address => address.domestic_client_id === projectDetails?.domestic_client_info_id)[0];
            }

            setContactId(projectDetails?.contact_id || 0);
            setCommercialClientProjectInfoId(projectDetails?.commercial_client_project_info_id || 0);
            setDomesticClientInfoId(projectDetails?.domestic_client_info_id || 0);
            setProjectType(projectDetails?.project_type || '');
            setSelectedProjectAddress(projectAddressData);
            /* ******** project address data set ********* */


            /* ******** status data set ********* */
            setStatus(statuses.filter(status => status.name === projectDetails?.status)[0]);
            /* ******** status data set ********* */

            /* ******** service type data set ********* */
            setServiceType(!isInspector ? (projectDetails?.service_type ?? []) : []);
            /* ******** service type data set ********* */

            /* ******** licence data set ********* */
            let subscriptionDetailsList: SubscriptionDetails[] | [];
            if (subscriptionDetails.length === 0) {
                subscriptionDetailsList = await GetAllSubscriptionDetails();
            } else {
                subscriptionDetailsList = subscriptionDetails;
            }
            // setSelectedLicence(subscriptionDetailsList.filter(subscription => subscription.subscription_id === projectDetails?.subscription_id)[0].subscription_name || null);

            const selectedSubscription = subscriptionDetailsList.find(subscription => subscription.subscription_id === projectDetails?.subscription_id);

            setSelectedLicence(selectedSubscription ? selectedSubscription.subscription_name : null);
            setLicence(projectDetails?.subscription_id || 0);
            setAssignLicence(null);
            /* ******** licence data set ********* */
        } else if (dataState === 'Renewal') {
            if (projectDetails && projectDetails !== null) {
                let subscriptionDetailsList: SubscriptionDetails[] | [];
                if (subscriptionDetails.length === 0) {
                    subscriptionDetailsList = await GetAllSubscriptionDetails();
                } else {
                    subscriptionDetailsList = subscriptionDetails;
                }

                const selectedSubscription = subscriptionDetailsList.find(subscription => subscription.subscription_id === projectDetails?.subscription_id);

                // if (selectedSubscription && selectedSubscription.is_free === 1) {
                //     const payableSubscription = subscriptionDetailsList.filter((plan) => plan.is_free === 0);

                //     if (payableSubscription && payableSubscription.length > 0) {
                //         setSelectedLicence(payableSubscription[0].subscription_name ? payableSubscription[0].subscription_name : null);
                //         setLicence(projectDetails?.subscription_id || 0);
                //         setAssignLicence(payableSubscription[0] || null);
                //     }
                // } else {
                //     setSelectedLicence(selectedSubscription ? selectedSubscription.subscription_name : null);
                //     setLicence(projectDetails?.subscription_id || 0);
                //     setAssignLicence(selectedSubscription || null);
                // }

                if (selectedSubscription && selectedSubscription !== null) {
                    setSelectedLicence(selectedSubscription ? selectedSubscription.subscription_name : null);
                    setLicence(projectDetails?.subscription_id || 0);
                    setAssignLicence(selectedSubscription || null);
                } else {
                    setSelectedLicence(null);
                    setLicence(null);
                    setAssignLicence(null);
                }
            } else {
                setSelectedLicence(null);
                setLicence(null);
                setAssignLicence(null);
            }
        }
    }

    /* ************************************************************************************************************************ */



    /* **************************************** project address data get - start ******************************************************************************** */
    const GetAllProjectAddress = async (): Promise<searchProjectAdderss[] | []> => {
        const data = await searchProjectAddressGetAPI("");
        if (data.status) {
            setAllProjectAddress(data.data || []);

            const result: searchProjectAdderss[] = data.data || [];
            return result;
        } else {
            return [];
        }
    }
    /* **************************************** project address data get - end ******************************************************************************** */

    /* **************************************** subscription Details - start ******************************************************************************** */
    const GetAllSubscriptionDetails = async (): Promise<SubscriptionDetails[] | []> => {
        const data = await subscriptionDetailsGetAPI();
        if (data.status) {
            setSubscriptionDetails(data.data || []);

            const result: SubscriptionDetails[] = data.data || [];
            return result;
        } else {
            return [];
        }
    }
    /* **************************************** subscription Details - end ******************************************************************************** */

    /* **************************************** service type - start ******************************************************************************** */
    const GetAllServiceType = async () => {
        const data = await serviceTypeGetAPI();
        if (data.status) {
            setAllServiceType(data.data || []);
        }
    }
    /* **************************************** service type - end ******************************************************************************** */

    /* **************************************** For Project address ******************************************************************************** */
    const handleAddressChange = (e: DropdownChangeEvent) => {
        const selectedOption = e.value as searchProjectAdderss | null;
        setSelectedProjectAddress(selectedOption);
        setContactId(selectedOption ? selectedOption.contact_id : null);
        setCommercialClientProjectInfoId(selectedOption ? selectedOption.commercial_client_id || null : null);
        setDomesticClientInfoId(selectedOption ? selectedOption.domestic_client_id || null : null);
        setProjectType(selectedOption ? selectedOption.project_type : '');
    };
    /*************************************** For Address  *****************************************/
    /* For showing selected address */
    const selectedAddressTemplate = (option: searchProjectAdderss, props: DropdownProps) => {
        if (option) {
            return (
                <div className="d-flex align-items-center overflow-hidden">
                    <div>{option.address}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    /* For showing address options in the dropdown list */
    const addressOptionTemplate = (option: searchProjectAdderss) => {
        return (
            <div className={`address_option_container ${option.project_type === 'Commercial' ? 'bg-blue' : 'bg-purple'}`}>
                <span>{option.address}</span>,&nbsp;<br />
                <span>{option.post_code}</span>,&nbsp;
                <span>{option.city}</span>
            </div>
        );
    };
    /**********************************************************************************************/
    /* **************************************** For Project address ******************************************************************************** */

    /* **************************************** For service type ******************************************************************************** */
    /* For add custom service type */
    const handleAddCustomServiceType = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMessage();

        if (checkCredentialsServiceType()) {
            setDataAddLoading(true);
            const data = await serviceTypeCreateAPI(serviceTypeName);

            setDataAddLoading(false);
            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        setErrorServiceTypeName(value[0])
                    ))
                }
            } else {
                /* clear data */
                setServiceTypeName('');
                setShowAddCustomData(false);
                /* call call data function */
                GetAllServiceType();

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Service type created successfully',
                        life: 3000
                    });
                }
            }
        }
    };

    useEffect(() => {
        checkText(serviceTypeName, false, setErrorServiceTypeName);
    }, [serviceTypeName]);

    function checkCredentialsServiceType(): boolean {
        const isValid = checkText(serviceTypeName, true, setErrorServiceTypeName);

        return isValid;
    }
    /* **************************************** For service type ******************************************************************************** */


    /* **************************** clear All error massage *************************** */
    const clearAllErrorMessage = () => {
        setErrorJobNo('');
        setErrorProjectAddress('');
        setErrorProjectType('');
        setErrorDescription('');
        setErrorServiceTypeName('');
        setErrorStatus('');
        setErrorLicence('');
        setErrorServiceType('');
    };
    /* **************************** clear All error massage *************************** */

    /* **************************** clear All input value *************************** */
    const clearAllInputValue = () => {
        setJobNo(null);
        setContactId(null);
        setCommercialClientProjectInfoId(null);
        setDomesticClientInfoId(null);
        setProjectType('');
        setDescription('');
        setStatus(statuses[0]);
        setLicence(null);
        setSelectedLicence(null);
        setServiceTypeName('');
        setSelectedProjectAddress(null);
        setAssignLicence(null);
        setServiceType([]);
        clearAllErrorMessage();
    };
    /* **************************** clear All input value *************************** */


    /* ************************************** For Project create, update - start *************************************************************** */
    useEffect(() => {
        checkNumber(jobNo || 0, false, setErrorJobNo);
    }, [jobNo]);

    useEffect(() => {
        checkNumber(contactId || 0, false, setErrorProjectAddress);
    }, [contactId]);

    useEffect(() => {
        checkText(projectType, false, setErrorProjectType);
    }, [projectType]);

    useEffect(() => {
        checkText(description, false, setErrorDescription);
    }, [description]);

    useEffect(() => {
        checkText(String(status?.name), false, setErrorStatus);
    }, [status]);

    useEffect(() => {
        checkNumber(licence || 0, false, setErrorLicence);
    }, [licence]);

    function checkCredentialsProject(): boolean {
        const isValidJobNo = checkNumber(jobNo || 0, true, setErrorJobNo);
        const isValidAddress = checkNumber(contactId || 0, true, setErrorProjectAddress);
        const isValidProjectType = checkText(projectType, true, setErrorProjectType);
        const isValidDescription = checkText(description, true, setErrorDescription);
        const isValidStatus = checkText(String(status?.name), true, setErrorStatus);

        if (dataState === 'Add') { // create 
            const isValidLicence = checkNumber(licence || 0, true, setErrorLicence);
            return isValidJobNo && isValidAddress && isValidProjectType && isValidDescription && isValidStatus && isValidLicence;
        } else { // update
            return isValidJobNo && isValidAddress && isValidProjectType && isValidDescription && isValidStatus;
        }
    }

    function showAPIErrorData(keyName: string, error: string): void {
        if (keyName === "job_number") {
            setErrorJobNo(error);
        }

        if (keyName === "description") {
            setErrorDescription(error);
        }
    }

    const handleCreateProject = async (e: React.FormEvent) => {
        e.preventDefault();

        const serviceTypeString = JSON.stringify(serviceType.map(item => item.id));

        if (checkCredentialsProject()) {
            setLoading(true);
            const data = await projectCreateAPI(
                "Contact Project",
                jobNo || 0,
                contactId || 0,
                licence || 0,
                commercialClientProjectInfoId || null,
                domesticClientInfoId || null,
                projectType,
                description,
                !isInspector ? serviceTypeString : '[]',
                status?.name || '',
                selectedProjectAddress?.address || '',
                selectedProjectAddress?.city || '',
                selectedProjectAddress?.post_code || ''
            );
            setLoading(false);

            if (data.statusCode === 200) {
                /* clear fields */
                clearAllInputValue();
                clearAllErrorMessage();

                /* get subscrption details */
                GetAllSubscriptionDetails();

                dispatch(fetchAllProjects());
                onSuccess('Project created successfully');
                onClose();
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorData(key, value[0])
                ))
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'There was an error creating the project.',
                        life: 3000
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (projectDetails) {
            const normalizedJobNo = jobNo?.toString().replace(/^0+/, "");
            const normalizedProjectJobNo = projectDetails?.job_number?.toString().replace(/^0+/, "");

            if (normalizedJobNo !== normalizedProjectJobNo) {
                setProjectUpdateHasChanges(true);
            } else if (contactId !== projectDetails?.contact_id) {
                setProjectUpdateHasChanges(true);
            } else if ((projectType).toLowerCase() !== (projectDetails?.project_type).toLowerCase()) {
                setProjectUpdateHasChanges(true);
            } else if (description && description !== projectDetails?.description) {
                setProjectUpdateHasChanges(true);
            } else if (
                JSON.stringify(serviceType.map(s => s.id).sort()) !==
                JSON.stringify(projectDetails?.service_type.map(s => s.id).sort())
            ) {
                setProjectUpdateHasChanges(true);
            } else if (status?.name !== projectDetails?.status) {
                setProjectUpdateHasChanges(true);
            } else {
                setProjectUpdateHasChanges(false);
            }
        }
    }, [
        projectDetails,
        jobNo,
        contactId,
        projectType,
        description,
        serviceType,
        status
    ]);

    const handleUpdateProject = async (e: React.FormEvent) => {
        e.preventDefault();

        const serviceTypeString = JSON.stringify(serviceType.map(item => item.id));

        if (checkCredentialsProject()) {
            setLoading(true);
            const data = await projectUpdateAPI(
                projectDetails?.project_id || 0,
                jobNo || 0,
                licence || 0,
                contactId || 0,
                commercialClientProjectInfoId || null,
                domesticClientInfoId || null,
                projectType,
                description,
                !isInspector ? serviceTypeString : '[]',
                status?.name || ''
            );
            setLoading(false);

            if (data.statusCode === 200) {
                dispatch(fetchAllProjectAfterEdit());
                onClose();
                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Project updated successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorData(key, value[0])
                    ))
                } else {
                    if (toast.current) {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'There was an error updating the project details.',
                            life: 3000
                        });
                    }
                }
            }
        }
    }

    /* For Change project license */
    function checkCredentialsProjectLicense(): boolean {
        const isValidLicence = checkNumber(licence || 0, true, setErrorLicence);

        return isValidLicence;
    }

    const handleUpdateProjectLicense = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsProjectLicense()) {
            setLoading(true);
            const data = await projectLicenseUpdateAPI(
                projectDetails?.project_id || 0,
                licence || 0
            );

            setLoading(false);

            if (data.statusCode === 200) {
                dispatch(fetchAllProjects());

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "The project license has been successfully renewed and updated.",
                        life: 3000,
                    });
                }

                onClose?.();
                onRenewalClose?.();
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorData(key, value[0])
                ))
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'There was an error updating the project license.',
                        life: 3000
                    });
                }
            }
        }
    }


    /* ************************************** For Project create, update - start *************************************************************** */
    const handleDeleteProject = () => {
        const projectId = projectDetails?.project_id;

        confirmDialog({
            message: 'Are you sure you want to delete this project?',
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteProject(projectId!),
            dismissableMask: true,
            resizable: false,
            draggable: false,
        });
    }

    const deleteProject = async (projectId: number) => {
        setDeleteLoading(true);
        const data = await projectDeleteAPI(projectId);

        setDeleteLoading(false);
        if (data.statusCode === 200) {
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Project deleted successfully.',
                    life: 3000
                });
            }
            onClose();
            GetAllSubscriptionDetails();
            dispatch(fetchAllProjects());
            navigate(`/project`);
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'There was an error deleting the project.',
                    life: 3000
                });
            }
        }
    }

    const handleCloseProjectModal = () => {
        onClose();

        if (dataState === 'Renewal') {
            const existingLicense = subscriptionDetails.find(
                (plan) => plan?.subscription_id === projectDetails?.subscription_id
            );

            setAssignLicence(existingLicense || null);
            setSelectedLicence(existingLicense?.subscription_name || '');
            setLicence(existingLicense?.subscription_id || null);
        } else {
            clearAllInputValue();
            clearAllErrorMessage();
        }
    }

    /* Modal header */
    const modalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState === 'Add' ? 'Add project' : dataState === 'Edit' ? 'Edit Project' : dataState === 'Renewal' ? 'Change license' : ''}
            </h5>

            {dataState === 'Edit' ? (
                <React.Fragment>
                    {deleteLoading ? (
                        <TableActionLoader className="is_modal_loader" />
                    ) : (
                        <button type="button" className="data_delete_btn p-ripple"
                            onClick={handleDeleteProject}>
                            <i className="bi bi-trash3"></i>
                            <Ripple />
                        </button>
                    )}
                </React.Fragment>
            ) : (
                <button type="button" className="close_modal_btn p-ripple"
                    onClick={handleCloseProjectModal}>
                    <i className="bi bi-x-circle"></i>
                    <Ripple />
                </button>
            )}
        </div>
    );

    /* Modal footer */
    const modalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseProjectModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : dataState === 'Edit' ? 'Update' : 'Submit'}
                onClick={dataState === 'Add' ? handleCreateProject : dataState === 'Edit' ? handleUpdateProject : handleUpdateProjectLicense}
                loading={loading}
                className="custom_btn primary"
                disabled={
                    (dataState === 'Renewal' && (assignLicence?.subscription_id === projectDetails?.subscription_id)) ||
                    (dataState === 'Renewal' && assignLicence === null) ||
                    (dataState === 'Edit' && !projectUpdateHasChanges)
                }
            />
        </div>
    );
    /**********************************************************************************************/

    /************************************* For status ***************************************/
    /* For showing selected status */
    const selectedStatusTemplate = (option: Status, props: DropdownProps) => {
        if (option) {
            return (
                <div className="d-flex align-items-center">
                    <div>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    /* For showing statuses options in the dropdown list */
    const statusOptionTemplate = (option: Status) => {
        return (
            <div className="d-flex align-items-center">
                <div>{option.name}</div>
            </div>
        );
    };
    /**********************************************************************************************/

    /*************************************** For License  *****************************************/
    const handleAssignLicense = () => {
        if (!assignLicence) return;

        if (assignLicence.available_count === 0) {
            setShowSubscriptionModal(true);
        } else {
            setSelectedLicence(assignLicence.subscription_name);
            setLicence(assignLicence.subscription_id);
        }

        setShowLicenceModal(false);
    };

    const handleClearLicenceSelection = () => {
        if (licence || selectedLicence || assignLicence) {
            setSelectedLicence('');
            setLicence(null);
            setAssignLicence(null);
        }
    }

    const handleCloseLicenseModal = () => {
        setShowLicenceModal(false);

        const existingLicense = subscriptionDetails.find(
            (plan) => plan?.subscription_id === projectDetails?.subscription_id
        );

        setAssignLicence(existingLicense || null);
    }

    /* Modal header */
    const licenseModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Project subscription
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseLicenseModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const licenseModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Cancel"
                className="custom_btn secondary"
                onClick={handleCloseLicenseModal}
            />

            <Button
                label={`${loading ? 'Processing' : (assignLicence?.license_count === 0 || assignLicence?.available_count === 0) ? 'Continue' : 'Assign'}`}
                disabled={(!assignLicence) || (dataState === 'Renewal' && assignLicence?.is_free === 1)}
                onClick={handleAssignLicense}
                loading={loading}
                className="custom_btn primary"
            />
        </div>
    );

    const renderPackages = () => {
        return (
            subscriptionDetails.map(pkg => (
                <li key={pkg.subscription_id}
                    className={`package_list_item 
                    ${pkg?.license_count === 0 && pkg?.available_count === 0 && pkg?.monthly_subscription_amount !== 0 ? 'highlighted info' : ''}
                    ${pkg?.available_count === 0 && pkg?.license_count !== 0 && pkg?.monthly_subscription_amount !== 0 ? 'highlighted warning' : ''}`}
                >
                    <div className="package_list_sub">
                        <div className="package_list_option">
                            <input
                                id={`package_${pkg.subscription_id}`}
                                className="radio_custom"
                                name="radio-group"
                                type="radio"
                                checked={assignLicence?.subscription_id === pkg.subscription_id}
                                onChange={() => setAssignLicence(pkg)}
                                disabled={
                                    (pkg?.available_count === 0 && pkg?.monthly_subscription_amount === 0) ||
                                    (dataState === 'Renewal' && pkg?.order_number < projectSubscription?.order_number!)}
                            />
                            <label
                                htmlFor={`package_${pkg.subscription_id}`}
                                className="radio_custom_label text-capitalize"
                                style={{
                                    opacity:
                                        (pkg?.available_count === 0 && pkg?.monthly_subscription_amount === 0) ||
                                            (dataState === 'Renewal' && pkg?.order_number < projectSubscription?.order_number!)
                                            ? 0.4 : 1
                                }}>
                                {pkg.subscription_name}

                                {pkg?.subscription_id === projectDetails?.subscription_id && (
                                    <React.Fragment>
                                        <Tooltip
                                            target={`.active_sub`}
                                        />

                                        <i className={`bi bi-check-circle active_sub ms-2`}
                                            data-pr-tooltip="Current license"
                                            data-pr-position="top"
                                        ></i>
                                    </React.Fragment>
                                )}
                            </label>
                        </div>
                        <div className="package_availability">
                            <h6 style={{
                                opacity:
                                    (pkg?.available_count === 0 && pkg?.monthly_subscription_amount === 0) ||
                                        (dataState === 'Renewal' && pkg?.order_number < projectSubscription?.order_number!)
                                        ? 0.4 : 1
                            }}>
                                <span>{pkg.available_count}</span>&nbsp; out of&nbsp; <span>{pkg.license_count}</span>
                            </h6>
                        </div>
                    </div>

                    {pkg?.license_count === 0 && pkg?.available_count === 0 && pkg?.monthly_subscription_amount !== 0 && (
                        <small className="package_list_info info">
                            You have not purchased this license, and once you select this, you can continue to purchase the license.
                        </small>
                    )}

                    {pkg?.license_count !== 0 && pkg?.available_count === 0 && pkg?.monthly_subscription_amount !== 0 && (
                        <small className="package_list_info warning">
                            You have used your all licenses, and once you have selected this, you can proceed to purchase an additional license.
                        </small>
                    )}
                </li>
            ))
        )
    };
    /**********************************************************************************************/


    /*************************************** Subscription *****************************************/
    const [showSubscriptionAlert, setShowSubscriptionAlert] = useState<boolean>(false);

    const handleShowSubscriptionAlert = () => {
        setShowSubscriptionAlert(true);
        // setTimeout(() => {
        //     setShowSubscriptionAlert(false);
        // }, 10000);
        goToTop();
    }

    const handleBuyPackage = () => {
        handlePurchaseLicense();
    }

    const cancelBuying = () => {
        setShowSubscriptionModal(false);

        const existingLicense = subscriptionDetails.find(
            (plan) => plan?.subscription_id === projectDetails?.subscription_id
        );
        setAssignLicence(existingLicense || null);

        setShowLicenceModal(true);
    }

    /* Modal header */
    const subscriptionModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {assignLicence?.license_count === 0 && assignLicence?.available_count === 0 ? 'Buy new subscription?' :
                    assignLicence?.license_count !== 0 && assignLicence?.available_count === 0 ? 'Buy additional subscription?' : ''}
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={cancelBuying}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const subscriptionModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Cancel"
                className="custom_btn secondary"
                onClick={cancelBuying}
            />

            <Button
                label="Buy"
                onClick={handleBuyPackage}
                className="custom_btn primary"
            />
        </div>
    );
    /**********************************************************************************************/


    /**********************************************************************************************/
    const toggleAddCustomData = () => {
        setShowAddCustomData(!showAddCustomData);
    };
    /**********************************************************************************************/


    /* For purchase license */
    useEffect(() => {
        if (assignLicence && assignLicence !== null) {
            const updatedLicense = subscriptionDetails?.find(data => data?.subscription_id === assignLicence?.subscription_id);

            setAssignLicence(updatedLicense || null);
        }
    }, [assignLicence, subscriptionDetails]);


    const handleCloseLicensePurchaseModal = () => {
        setShowLicensePurchaseModal(false);
        setShowSubscriptionModal(true);
    }

    const handlePurchaseLicense = () => {
        setShowLicensePurchaseModal(true);
        setShowSubscriptionModal(false);
    }

    const licensePurchaseModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">Purchase subscription.</h5>
            <button
                type="button"
                className="close_modal_btn p-ripple"
                onClick={handleCloseLicensePurchaseModal}
            >
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const licensePurchaseModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Cancel"
                className="custom_btn secondary"
                onClick={handleCloseLicensePurchaseModal}
            />
        </div>
    );

    useEffect(() => {
        const handleGetPaymentTypes = async () => {
            setLoadingPaymentMethods(true)
            const res = await getPaymentTypes();
            setLoadingPaymentMethods(false)

            if (res.status) {
                setPaymentMethodsData(mapPaymentTypes(res.body.data));
            }
        }
        handleGetPaymentTypes();
    }, []);

    const handlePayWith = (paymentMethod: PaymentType) => {
        setSelectedPaymentMethod(paymentMethod);
        const taxAmount = assignLicence?.monthly_subscription_amount! * (assignLicence?.tax_percentage! / 100);

        const total = assignLicence?.monthly_subscription_amount! + taxAmount;
        setPaidTotal(total);
        setShowCheckoutForm(true);
    };

    const handlePaymentSuccess = async (paymentIntent: PaymentIntent | undefined) => {
        if (paymentIntent?.status === "succeeded") {
            setShowCheckoutForm(false);
            setShowLicensePurchaseModal(false);
            setShowSubscriptionModal(false);
            setShowLicenceModal(true);

            const result = await buyLicense(
                selectedPaymentMethod?.id!,
                assignLicence?.subscription_id!,
                paymentIntent.id,
            );

            if (result.status) {
                GetAllSubscriptionDetails();
                dispatch(fetchAllProjects());

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "License purchased successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "An error occurred in the purchase license.",
                        life: 3000,
                    });
                }
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: "error",
                    summary: "Failed",
                    detail: "An error occurred in the purchase license.",
                    life: 3000,
                });
            }
        }
    };


    return (
        <React.Fragment>
            {/* *************************************** Add project modal ************************************** */}
            <Dialog
                visible={isOpen}
                header={modalHeader}
                footer={modalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseProjectModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
                        <div className="row">
                            {dataState === 'Add' || dataState === 'Edit' ? (
                                <React.Fragment>
                                    {/* Job no. */}
                                    <div className="col-12 col-sm-6 pe-sm-2">
                                        <div className="page_form_group">
                                            <label htmlFor="jobNo" className={`custom_form_label is_required`}>Job No.</label>
                                            <InputNumber
                                                className="w-100"
                                                inputId="jobNo"
                                                value={jobNo}
                                                placeholder="Enter project job number"
                                                onChange={(e: InputNumberChangeEvent) => setJobNo(e.value)}
                                                useGrouping={false}
                                            />
                                            {errorJobNo &&
                                                <small className="form_error_msg">{errorJobNo}</small>
                                            }
                                        </div>
                                    </div>

                                    {/* Status * */}
                                    <div className="col-12 col-sm-6 ps-sm-2">
                                        <div className="page_form_group">
                                            <label htmlFor="status" className="custom_form_label is_required">Status</label>
                                            <Dropdown
                                                id="status"
                                                value={status}
                                                onChange={(e: DropdownChangeEvent) => setStatus(e.value)}
                                                options={statuses}
                                                optionLabel="name"
                                                valueTemplate={selectedStatusTemplate}
                                                itemTemplate={statusOptionTemplate}
                                                placeholder="Select status"
                                                className="form_dropdown w-100"
                                                showClear
                                            />

                                            {errorStatus &&
                                                <small className="form_error_msg">{errorStatus}</small>
                                            }
                                        </div>
                                    </div>

                                    {/* Address */}
                                    <div className="col-12">
                                        <div className="page_form_group">
                                            <label htmlFor="address" className="custom_form_label is_required">Address</label>

                                            <Dropdown
                                                value={selectedProjectAddress}
                                                id="address"
                                                onChange={handleAddressChange}
                                                options={allProjectAddress}
                                                optionLabel="address"
                                                valueTemplate={selectedAddressTemplate}
                                                itemTemplate={addressOptionTemplate}
                                                emptyFilterMessage="No address(es) found!"
                                                placeholder="Select address"
                                                className="form_dropdown address_selection w-100"
                                                filter
                                                showClear
                                                filterInputAutoFocus
                                                filterPlaceholder="Search address"
                                                panelClassName="address_dropdown_panel"
                                            />

                                            {errorProjectAddress &&
                                                <small className="form_error_msg">{errorProjectAddress}</small>
                                            }
                                        </div>
                                    </div>

                                    {/* Project type */}
                                    <div className="col-12">
                                        <div className="page_form_group">
                                            <label htmlFor="projectType" className="custom_form_label">
                                                Project type
                                                {projectType === '' && (
                                                    <small className="text-muted">&nbsp;(Select the address above.)</small>
                                                )}
                                            </label>
                                            {/* <Dropdown value={projectType} id="projectType" onChange={(e: DropdownChangeEvent) => setProjectType(e.value)}
                                            options={project_types} optionLabel="type" valueTemplate={selectedProjectTypeTemplate} itemTemplate={projectTypeOptionTemplate}
                                            placeholder="Project type" className="form_dropdown w-100" showClear /> */}

                                            <InputText
                                                id="pro"
                                                value={projectType}
                                                className="custom_form_input"
                                                placeholder="Project type"
                                                disabled
                                            />

                                            {errorProjectType &&
                                                <small className="form_error_msg">{errorProjectType}</small>
                                            }
                                        </div>
                                    </div>

                                    {/* Description */}
                                    <div className="col-12">
                                        <TextInput
                                            id="description"
                                            label="Description"
                                            labelHtmlFor="description"
                                            required={true}
                                            value={description}
                                            placeholder="Enter project description here"
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)}
                                            error={errorDescription}
                                        />
                                    </div>

                                    {/* Service type */}
                                    {!isInspector && (
                                        <div className="col-12">
                                            <div className="page_form_group">
                                                <div className="w-100">
                                                    <label htmlFor="serviceType" className="custom_form_label">Service type</label>
                                                    <MultiSelect
                                                        value={serviceType}
                                                        onChange={(e: MultiSelectChangeEvent) => setServiceType(e.value)}
                                                        options={allServiceType}
                                                        display="chip"
                                                        optionLabel="name"
                                                        showClear
                                                        placeholder="Service type"
                                                        filter
                                                        filterInputAutoFocus={true}
                                                        filterPlaceholder="Search service type.."
                                                        maxSelectedLabels={4}
                                                        className="w-100"
                                                        emptyFilterMessage="No service type(s) found!"
                                                        emptyMessage={
                                                            (() => (
                                                                <span>
                                                                    No service types have been added. <br /> To add, click the Add button.
                                                                </span>
                                                            )) as any
                                                        }
                                                    />

                                                    {errorServiceType &&
                                                        <small className="form_error_msg">{errorServiceType}</small>
                                                    }
                                                </div>

                                                <div className="add_data_area">
                                                    <button className={`add_data_btn ${showAddCustomData ? 'danger' : ''} p-ripple`} onClick={toggleAddCustomData}>
                                                        <i className={`bi ${showAddCustomData ? 'bi-dash-circle' : ' bi-plus-circle'}`}></i>
                                                        {showAddCustomData ? (<span>Cancel</span>)
                                                            : (<span>Add custom service type</span>)
                                                        }
                                                        < Ripple />
                                                    </button>

                                                    <div className={`add_data_input_area ${showAddCustomData ? 'show' : ''}`}>
                                                        <InputText
                                                            id="serviceType"
                                                            value={serviceTypeName}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setServiceTypeName(e.target.value)}
                                                            className="custom_form_input"
                                                            placeholder="Enter service type name"
                                                        />

                                                        <Button
                                                            label="Add"
                                                            className="dwn_data_add_btn"
                                                            onClick={handleAddCustomServiceType}
                                                            loading={dataAddLoading}
                                                            disabled={serviceTypeName === ''}
                                                        />
                                                    </div>
                                                    {errorServiceTypeName &&
                                                        <small className="form_error_msg">{errorServiceTypeName}</small>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </React.Fragment>
                            ) : dataState === 'Renewal' ? (
                                <React.Fragment>
                                    <div className="col-12">
                                        <div className="page_form_group">
                                            <label className="custom_form_label mb-1">
                                                Project details
                                            </label>

                                            {projectDetails && projectDetails !== null ? (
                                                <article className="payment_summary_area">
                                                    <div className="payment_summary_info">
                                                        <h6>Job number</h6>
                                                        <p>{projectDetails?.job_number ? projectDetails?.job_number : '----'}</p>
                                                    </div>
                                                    <div className="payment_summary_info">
                                                        <h6>Address</h6>
                                                        <p className="text-capitalize">{projectDetails?.address ? projectDetails?.address : '----'}</p>
                                                    </div>
                                                    <div className="payment_summary_info">
                                                        <h6>End of date</h6>
                                                        <p>{projectDetails?.end_of_date ? projectDetails?.end_of_date : '----'}</p>
                                                    </div>
                                                    <div className="payment_summary_info">
                                                        <h6>Stauts</h6>
                                                        <p>{projectDetails?.status ? projectDetails?.status : '----'}</p>
                                                    </div>
                                                </article>
                                            ) : (
                                                <div className="no_records_found" style={{ minHeight: "25vh" }}>
                                                    <i className="bi bi-exclamation-circle me-1"></i>
                                                    No details found.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </React.Fragment>
                            ) : null}

                            {/* Assign licence */}
                            <div className="col-12">
                                <div className="page_form_group mb-2">
                                    <label htmlFor="license" className={`custom_form_label ${dataState !== 'Edit' ? 'is_required' : ''}`}>
                                        {dataState === 'Renewal' ? 'Change license' : 'Assign license'}
                                    </label>
                                    {dataState === 'Add' || dataState === 'Renewal' ? (
                                        <IconField iconPosition="right">
                                            {licence && selectedLicence ? (
                                                <InputIcon className="bi bi-x clear_button input_clear_btn" onClick={handleClearLicenceSelection}></InputIcon>
                                            ) : (
                                                <InputIcon className="bi bi-chevron-right pointer-event-none"> </InputIcon>
                                            )}
                                            <InputText
                                                id="license"
                                                value={selectedLicence}
                                                className="custom_form_input cursor_pointer is_readonly"
                                                placeholder="Choose the license"
                                                onClick={() => setShowLicenceModal(true)}
                                                readOnly
                                            />
                                        </IconField>
                                    ) : dataState === 'Edit' ? (
                                        <InputText
                                            id="license"
                                            value={selectedLicence}
                                            className="custom_form_input cursor_pointer"
                                            placeholder="License"
                                            disabled
                                        />
                                    ) : null}

                                    {errorLicence &&
                                        <small className="form_error_msg">{errorLicence}</small>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >
            {/* ************************************************************************************************ */}


            {/* ************************************* Assign licence modal ************************************* */}
            <Dialog
                visible={showLicenceModal}
                header={licenseModalHeader}
                footer={licenseModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseLicenseModal}
            >
                <div className="custom_modal_body">
                    <div className="p-1 w-100">
                        <div className="row">
                            <div className="col-12">
                                {subscriptionDetails?.length > 0 ? (
                                    <React.Fragment>
                                        <div className="package_list_header">
                                            <h6 className="mb-0">Plan</h6>
                                            <h6 className="mb-0">Available count</h6>
                                        </div>
                                        <ul className="package_list">
                                            {renderPackages()}
                                        </ul>
                                    </React.Fragment>
                                ) : (
                                    <div className="no_data_found">
                                        <h6>No packages found!</h6>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/* ************************************************************************************************ */}


            {/* *************************************** Subscription modal ************************************** */}
            <Dialog
                visible={showSubscriptionModal}
                header={subscriptionModalHeader}
                footer={subscriptionModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={() => { if (!showSubscriptionModal) return; setShowSubscriptionModal(false); }}
            >
                <div className="custom_modal_body">
                    <div className="p-1 w-100">
                        <div className="row">
                            <div className="col-12">
                                {assignLicence && (
                                    <div className="subscription_data_area">
                                        <h6>{assignLicence.subscription_name}</h6>
                                        <h3>{currencySymbol}&nbsp;
                                            {assignLicence.monthly_subscription_amount}
                                            &nbsp;
                                            <span>/m/project</span>
                                        </h3>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/* ************************************************************************************************ */}


            {/* License purchase modal */}
            <Dialog
                visible={showLicensePurchaseModal}
                header={licensePurchaseModalHeader}
                footer={licensePurchaseModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseLicensePurchaseModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 w-100">
                        <div className="row">
                            {assignLicence && assignLicence !== null ? (
                                <div className="col-12">
                                    <div className="page_form_group mb-3">
                                        <label className="custom_form_label mb-1">
                                            Plan details
                                        </label>

                                        <article className={`payment_summary_area`}>
                                            <div className="payment_summary_info">
                                                <h6>Subscription</h6>
                                                <p>{assignLicence?.subscription_name}(1)</p>
                                            </div>

                                            <div className="payment_summary_info">
                                                <h6>Amount</h6>
                                                <p>
                                                    {currencySymbol}&nbsp;
                                                    {assignLicence?.monthly_subscription_amount?.toFixed(1)}
                                                </p>
                                            </div>

                                            <div className="payment_summary_info">
                                                <h6>
                                                    Tax ({assignLicence?.tax_percentage?.toFixed(1)}%)
                                                </h6>
                                                <p>
                                                    {currencySymbol}&nbsp;
                                                    {(assignLicence?.monthly_subscription_amount! * (assignLicence?.tax_percentage! / 100))?.toFixed(1)}
                                                </p>
                                            </div>

                                            <div className="payment_summary_info">
                                                <h6>Subtotal</h6>
                                                <p>
                                                    {currencySymbol}&nbsp;
                                                    {(assignLicence?.monthly_subscription_amount! + assignLicence?.monthly_subscription_amount! * (assignLicence?.tax_percentage! / 100))?.toFixed(1)}
                                                </p>
                                            </div>
                                        </article>
                                    </div>

                                    <div className="page_form_group mb-2">
                                        <label className="custom_form_label mb-1">
                                            Payment with
                                        </label>

                                        {loadingPaymentMethods ? (
                                            <div className="payment_option_area">
                                                <Skeleton className="payment_option_loading">
                                                    <Skeleton className="logo" />
                                                    <Skeleton className="label" />
                                                </Skeleton>
                                            </div>
                                        ) : (
                                            <React.Fragment>
                                                {paymentMethodsData && paymentMethodsData?.length > 0 ? (
                                                    <div className="payment_option_area" id="paymentOption">
                                                        {paymentMethodsData?.map((paymentMethod) => (
                                                            <button
                                                                key={paymentMethod?.id}
                                                                className="payment_option p-ripple"
                                                                onClick={() => handlePayWith(paymentMethod)}
                                                            >
                                                                <div className="payment_option_info">
                                                                    <Image
                                                                        src={baseURL + paymentMethod?.logo}
                                                                        alt={paymentMethod?.type}
                                                                    />
                                                                    <p>{paymentMethod?.type}</p>
                                                                </div>

                                                                <i className="bi bi-chevron-right"></i>
                                                                <Ripple />
                                                            </button>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <div className="no_records_found" style={{ minHeight: "15vh" }}>
                                                        <i className="bi bi-exclamation-circle me-1"></i>
                                                        No payment option(s) found.
                                                    </div>
                                                )}
                                            </React.Fragment>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className="col-12">
                                    <div className="no_records_found" style={{ minHeight: "25vh" }}>
                                        <i className="bi bi-exclamation-circle me-1"></i>
                                        No data found.
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            <CheckoutForm
                isOpen={showCheckoutForm}
                onClose={() => setShowCheckoutForm(false)}
                onPaymentSuccess={handlePaymentSuccess}
                amount={paidTotal * 100}
            />


            {/* Subscription alert */}
            <Dialog
                visible={showSubscriptionAlert}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_md"
                onHide={() => { if (!showSubscriptionAlert) return; setShowSubscriptionAlert(false); }}
            >
                <div className="custom_modal_body">
                    <button className="custom_modal_close position-absolute float p-ripple"
                        onClick={() => setShowSubscriptionAlert(false)}>
                        <i className="bi bi-x-lg"></i>
                        <Ripple />
                    </button>

                    <div className="use_case_feature_info">
                        <h6 className="review_head">Subscription Alert!</h6>

                        <div className="message_alert_area">
                            <img src="/assets/images/alert_image.svg" alt="Subscription Alert!" />

                            <p className="review_paragraph text-center">
                                This service is currently not available on the web version. Kindly use the <b>Mobile app</b> to purchase or upgrade the paid packages.
                            </p>

                            <div className="mobile_apps_link_area">
                                <Link target="_blank" to={appStoreLink} className="mb_app_link p-ripple">
                                    <img src="/assets/images/website/home-page/app_store.svg" alt="App Store" loading="lazy" />
                                    <Ripple />
                                </Link>
                                <Link target="_blank" to={playStoreLink} className="mb_app_link p-ripple">
                                    <img src="/assets/images/website/home-page/play_store.svg" alt="Play Store" loading="lazy" />
                                    <Ripple />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    )
}
export default ProjectModal;